app.farmnetControllers.addCustomCode('fieldCoreController', function(
  $scope,
  controller,
  $injector,
  $log
) {
  $injector.invoke([
    'i18nFilter',
    function(i18nFilter) {
	  ang.overrideFunction(controller, 'propertyChanged', function(propertyChanged, property) {
		if (controller.isSwissBartoUser && property === 'usage') {
		  controller.updateFieldIntensityBarto();
	  	}
		return propertyChanged(property);
	  });

      ang.overrideFunction(controller, 'addClick', function(addClick, data) {
        $scope.isGrasslandOrPasture = false;
        return addClick(data);
      });

      ang.overrideFunction(controller, 'setSavedState', function(
        setSavedState,
        details
      ) {
        var hasErrors = setSavedState(details);
        if (
          details &&
          details.field &&
          details.field.farmedArea > details.field.geoArea
        ) {
          $scope.$rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.core.field.farmedAreaDimetionInfo',
              'Bewirtschaftete Fläche größer als geografische Fläche!'
            )
          );
        }
        controller.updateList();
        return hasErrors;
      });

      ang.overrideFunction(controller, 'onShowDetails', function(
        oldShowDetails
      ) {
        oldShowDetails();

        controller.hasName = true;
        //aht: Wenn kein Schlagname gestezt ist wird die mapptoolbar ausgeblendet
        if (
          $scope.details &&
          $scope.details.field &&
          !$scope.details.field.name
        ) {
          controller.hasName = false;
        }

        $scope.$watch('details.field.name', function(newVal, oldVal) {
          if (oldVal === newVal) return;
          controller.hasName = !(
            $scope.details &&
            $scope.details.field &&
            !$scope.details.field.name
          );
        });

        if (!$scope.details || !$scope.details.field) {
          return;
        }

        //validTo will only be set if it's not valid anymore, if we allow validTo to be defined for the future add this:
        // && $scope.details.field.validTo < new Date().getTime(); // check that it works in other timezones!!
        $scope.isHistoricalData = !!$scope.details.field.validTo;

        controller.hasGeometry = function() {
          if (!$scope.details) {
            return false;
          }

          if (
            $scope.details.field &&
            $scope.details.field.geometry !== null &&
            $scope.details.field.geometry !== undefined
          ) {
            return $scope.details.field.geometry ? true : false;
          }
        };

        /**
         * Toggles the state of all input elements but leaves certain ones
         * always enabled.
         * The 'active' checkbox is always enabled and the link to delete the
         * field stays visible.
         * @param enabled Enable or disable the fields?
         */
        function toggleEditableState(enabled) {
          // Deactivate all input elements
          var $inputs = $('#viewDiv')
            .find('.detailsRight, .detailsLeft')
            .find('input, button, select');
          $inputs.prop('disabled', !enabled); //all inputs including active checkbox

          // Reactivate the 'active' checkbox (unless we are displaying historical data)
          var $activateCheckbox = $(
            'input[model="fieldCoreController.details.field.active"]'
          );
          $activateCheckbox.prop('disabled', $scope.isHistoricalData);

          var $detailsButtons = $('.detailsButtons');

          // Reactive the 'delete' button
          // Do not reactivate delete buttons with no-auto-active class
          var $deleteButton = $detailsButtons
            .find('button .farmnet-delete')
            .not('.no-auto-active')
            .parent();
          $deleteButton.prop('disabled', false);

          // Hide or show the 'duplicate' link
          var $duplicateItem = $detailsButtons.find('ul > li:last');
          $duplicateItem.css('display', !enabled ? 'none' : '');

          //... workaround for new button "draw field boundaries"
          if (enabled) {
            var createBoundaries = $('#btnFieldBoundariesCreate');
            createBoundaries.prop('disabled', !controller.hasName);
          }
        }

        $scope.$watch('details.field.active', function(active) {
          toggleEditableState(active);
        });

        // If the field is inactive deactivate all inputs. CFNPOC-5292
        if (
          $scope.details &&
          $scope.details.field &&
          !$scope.details.field.active
        ) {
          toggleEditableState(false);
        }
      });
    }
  ]);
  return controller;
});
